<app-panel-header-image-view pretitle="{{'Coaches' | transloco}}" title="{{'Search' | transloco}}" banner_image="../../../../modules/custom/wa_angular/app/assets/images/coaches-header.jpg"></app-panel-header-image-view>

<app-app-content-page-wrapper>
  <lib-filters-component [filters_options]="filter_service.filtersType"></lib-filters-component>
  <app-wa-table [customMsgBox]="customBox" [showNoResultsMessageCondition]="ShowNoResultsBox" [isSortableFunc]="sortClass" [showCondition]="true" [headers]="headers" [isDataLoading]="loading"
    [areMoreData]="areMoreData()" (loadMore)="loadMore()" [data]="data" (headerClick)="changeSort($event)">
    <app-search-box-table #customBox [subtitle]="'find.coaches' | transloco">

    </app-search-box-table>
    <ng-template [extraClass]="['wa-table__cell--fit-right']" app-column let-athlete>
                  <lib-athlete-photo [id]="athlete.Id" [isTeam]="false"></lib-athlete-photo>

    </ng-template>
    <ng-template  app-column let-athlete>
      <lib-athlete-name [fname]="athlete.FName" [gname]="athlete.GName" [wnameord]="athlete.WNameOrd" [id]="athlete.Id"></lib-athlete-name>
    </ng-template>
    <ng-template  [extraClass]="[]" app-column let-athlete>
      <lib-country-flag [name]="getCountryName(getCountryCode(athlete))" [id]="getCountryCode(athlete)"> </lib-country-flag>
    </ng-template>
    <ng-template  [extraClass]="[]" app-column let-athlete>
      <lib-country-flag [name]="getCountryName(athlete.Nationality)" [id]="athlete.Nationality"> </lib-country-flag>
    </ng-template>
    <ng-template  [extraClass]="[]" app-column let-athlete>
      <div class="uppertext">{{athlete.Age}}</div>
    </ng-template>

    <ng-template [extraClass]="['wa-table__cell--fit-right']" app-column-responsive let-athlete>
      <lib-athlete-photo [id]="athlete.Id" [isTeam]="false"></lib-athlete-photo>
    </ng-template>
    <ng-template  app-column-responsive let-athlete>
      <lib-athlete-name [fname]="athlete.FName" [gname]="athlete.GName" [wnameord]="athlete.WNameOrd" [id]="athlete.Id"></lib-athlete-name>
      <div class="inner-info">
        <div><p class="uppertext-black">{{'Country' | transloco}}:          </p>  <lib-country-flag [name]="getCountryName(getCountryCode(athlete))" [id]="getCountryCode(athlete)"> </lib-country-flag> </div>
        <div><p class="uppertext-black">{{'Nationality' | transloco}}:         </p>  <lib-country-flag [name]="getCountryName(athlete.Nationality)" [id]="athlete.Nationality"> </lib-country-flag>  </div>
        <div class="uppertext"><p class="uppertext-black">{{'Age' | transloco}}:         </p>  {{athlete.Age}}  </div>

      </div>
    </ng-template>

  </app-wa-table>
  <app-news-panel [title]="'related_news' | transloco"  [news]="news" *ngIf="news && news.length > 0"></app-news-panel>
</app-app-content-page-wrapper>
